<!-- 网站服务条款及用户协议 -->
<template>
  <div class="certificate">
    <img src="https://cdn.welove520.com/static/res/vue/playbay/certificate.jpg">
  </div>
</template>

<script>
export default {
  name: "Certificate",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "certificate");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.certificate {
    width: 1000px;
    margin: 0 auto;
}

.certificate > img {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Certificate.vue